module.exports = __webpack_public_path__ + "img/TemplarAssassin.18c426ad.png";